import {
  useEffect,
  useState
} from "react";

import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaTruck
} from "react-icons/fa";

import MainLayout from "../../components/layout/MainLayout";

import {
  getSuppliers,
  createSupplier,
  updateSupplier,
  deleteSupplier
} from "../../api/supplierApi";

const Suppliers = () => {

  const [suppliers,setSuppliers] =
  useState([]);

  const [showModal,setShowModal] =
  useState(false);

  const [editingId,setEditingId] =
  useState(null);

  const [form,setForm] =
  useState({

    supplier_name:"",
    contact_person:"",
    mobile:"",
    email:"",
    gst_no:"",
    address:"",
    status:"active"

  });

  useEffect(()=>{

    loadSuppliers();

  },[]);

  const loadSuppliers =
  async()=>{

    try{

      const res =
      await getSuppliers();

      setSuppliers(
        res.data.data || []
      );

    }
    catch(error){

      console.log(error);

    }

  };

  const resetForm =
  ()=>{

    setEditingId(null);

    setForm({

      supplier_name:"",
      contact_person:"",
      mobile:"",
      email:"",
      gst_no:"",
      address:"",
      status:"active"

    });

  };

  const saveSupplier =
  async(e)=>{

    e.preventDefault();

    try{

      if(editingId){

        await updateSupplier(
          editingId,
          form
        );

      }
      else{

        await createSupplier(
          form
        );

      }

      loadSuppliers();

      setShowModal(false);

      resetForm();

    }
    catch(error){

      console.log(error);

    }

  };

  const editSupplier =
  (supplier)=>{

    setEditingId(
      supplier.id
    );

    setForm(
      supplier
    );

    setShowModal(true);

  };

  const removeSupplier =
  async(id)=>{

    if(
      !window.confirm(
        "Delete Supplier?"
      )
    ) return;

    await deleteSupplier(id);

    loadSuppliers();

  };

  return(

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white d-flex justify-content-between align-items-center">

          <div>

            <h5 className="mb-0">
              Supplier Master
            </h5>

            <small className="text-muted">
              Manage Vendors & Suppliers
            </small>

          </div>

          <button
            className="btn btn-primary"
            onClick={()=>
              setShowModal(true)
            }
          >

            <FaPlus />
            {" "}
            Add Supplier

          </button>

        </div>

        <div className="card-body">

          <table className="table table-hover align-middle">

            <thead>

              <tr>

                <th>Supplier</th>
                <th>Contact</th>
                <th>Mobile</th>
                <th>GST</th>
                <th>Status</th>
                <th width="120">
                  Action
                </th>

              </tr>

            </thead>

            <tbody>

              {
                suppliers.map(
                  (item)=>(
                    <tr
                      key={item.id}
                    >

                      <td>

                        <FaTruck
                          className="text-primary me-2"
                        />

                        {item.supplier_name}

                      </td>

                      <td>
                        {item.contact_person}
                      </td>

                      <td>
                        {item.mobile}
                      </td>

                      <td>
                        {item.gst_no}
                      </td>

                      <td>

                        <span
                          className={
                            item.status==="active"
                            ?
                            "badge bg-success"
                            :
                            "badge bg-danger"
                          }
                        >

                          {item.status}

                        </span>

                      </td>

                      <td>

                        <button
                          className="btn btn-warning btn-sm me-2"
                          onClick={()=>
                            editSupplier(item)
                          }
                        >

                          <FaEdit />

                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={()=>
                            removeSupplier(item.id)
                          }
                        >

                          <FaTrash />

                        </button>

                      </td>

                    </tr>
                  )
                )
              }

            </tbody>

          </table>

        </div>

      </div>

      {/* Modal */}

      {showModal && (

        <div
          className="modal d-block"
          style={{
            background:
            "rgba(0,0,0,.5)"
          }}
        >

          <div className="modal-dialog modal-lg">

            <div className="modal-content">

              <form
                onSubmit={saveSupplier}
              >

                <div className="modal-header">

                  <h5>

                    {
                      editingId
                      ?
                      "Edit Supplier"
                      :
                      "Add Supplier"
                    }

                  </h5>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={()=>{
                      setShowModal(false);
                      resetForm();
                    }}
                  />

                </div>

                <div className="modal-body">

                  <div className="row">

                    <div className="col-md-6 mb-3">

                      <label>
                        Supplier Name
                      </label>

                      <input
                        className="form-control"
                        value={form.supplier_name}
                        onChange={(e)=>
                          setForm({
                            ...form,
                            supplier_name:e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Contact Person
                      </label>

                      <input
                        className="form-control"
                        value={form.contact_person}
                        onChange={(e)=>
                          setForm({
                            ...form,
                            contact_person:e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Mobile
                      </label>

                      <input
                        className="form-control"
                        value={form.mobile}
                        onChange={(e)=>
                          setForm({
                            ...form,
                            mobile:e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Email
                      </label>

                      <input
                        className="form-control"
                        value={form.email}
                        onChange={(e)=>
                          setForm({
                            ...form,
                            email:e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        GST Number
                      </label>

                      <input
                        className="form-control"
                        value={form.gst_no}
                        onChange={(e)=>
                          setForm({
                            ...form,
                            gst_no:e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Status
                      </label>

                      <select
                        className="form-select"
                        value={form.status}
                        onChange={(e)=>
                          setForm({
                            ...form,
                            status:e.target.value
                          })
                        }
                      >

                        <option value="active">
                          Active
                        </option>

                        <option value="inactive">
                          Inactive
                        </option>

                      </select>

                    </div>

                    <div className="col-md-12">

                      <label>
                        Address
                      </label>

                      <textarea
                        rows="3"
                        className="form-control"
                        value={form.address}
                        onChange={(e)=>
                          setForm({
                            ...form,
                            address:e.target.value
                          })
                        }
                      />

                    </div>

                  </div>

                </div>

                <div className="modal-footer">

                  <button
                    className="btn btn-primary"
                  >

                    Save Supplier

                  </button>

                </div>

              </form>

            </div>

          </div>

        </div>

      )}

    </MainLayout>

  );

};

export default Suppliers;